module.exports = __webpack_public_path__ + "img/preferably.ef08d217.png";